import React from 'react';
import { useToast } from '@chakra-ui/react';
import { useMutation } from '@tanstack/react-query';
import * as UsersApi from '@Modules/admin/users/api/UsersApi';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import CustomReactTable from '@Modules/core/components/table/CustomReactTable';
import CustomAppModal from '@Modules/core/components/modal/CustomModal';
import BankMarchantsCategoryFormMeta from './BankMarchantsCategoryFormMeta';
import { IBankMarchantsCategoryDatatable } from './bankMarchantsCategoryDatatableMeta';
import { BankMarchantsCategoryGroupDatatableMeta } from '../BankMarchantsCategoryGroupFormHandler/bankMarchantsCategoryGroupDatatableMeta';
import BankMarchantsCategoryFormUI from '@Modules/admin/basicSettings/components/formsUI/bank/marchants/BankMarchantsCategoryFormUI';

export default function BankMarchantsCategoryMixteHandle() {
  const editUsersModal = React.useRef<any>(null);

  const toast = useToast();
  const { isLoading } = useMutation(UsersApi.createProfile, {
    onSuccess: (data) => {
      console.log('Response: ', data);
      toast({
        position: 'top-right',
        title: 'effectué avec succès',
        isClosable: true,
        status: 'success',
      });
    },
    onError: (error) => {
      console.log('Error: ', error);
    },
  });

  const data: IBankMarchantsCategoryDatatable[] = [
    {
      id: '',
      name: '',
    },
    {
      id: '',
      name: '',
    },
    {
      id: '',
      name: '',
    },
  ];

  const onSubmit = (payload: any) => {
    console.log('payload: ', payload);
  };

  const handleEdit = (row: any) => {
    editUsersModal?.current?.onOpen();
  };

  return (
    <>
      <CC.Box>
        <BankMarchantsCategoryFormUI
          isLoading={isLoading}
          isSubmitting={isLoading}
          meta={BankMarchantsCategoryFormMeta}
          onSubmit={onSubmit}
        />
      </CC.Box>

      <CC.Box>
        <CustomReactTable
          data={data}
          columns={BankMarchantsCategoryGroupDatatableMeta.columns(handleEdit)}
        />
      </CC.Box>

      <CC.Box>
        <CustomAppModal
          title="Editer "
          ref={editUsersModal}
          actionBtnText="Editer"
          actionBtnClick={() => editUsersModal?.current?.onClose()}
        >
          Edit form
        </CustomAppModal>
      </CC.Box>
    </>
  );
}
